import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { Discount } from 'molecules/Discount';
import { Price } from 'molecules/Price';
import styles from './styles.module.css';

export const ProductDiscount: FC<{
  currencyCode: string;
  discountPercentage: number;
  recommendedPrice?: number | null;
  color?: 'white';
  className?: string;
}> = ({
  recommendedPrice,
  currencyCode,
  color,
  discountPercentage,
  className,
}) => {
  return (
    <div className={clsx(styles.discount, className)}>
      <Price
        amount={recommendedPrice}
        currencyCode={currencyCode}
        isCrossed
        color={color}
      />
      <Discount discountPercentage={discountPercentage} />
    </div>
  );
};

export const PriceInfo: FC<
  PropsWithChildren & { className?: string; type?: 'row' | 'column' }
> = ({ children, className = '', type = 'row' }) => {
  return (
    <div className={clsx(styles.priceInfo, className, styles[type])}>
      {children}
    </div>
  );
};
